import {defineStore} from 'pinia'
import {readonly, ref} from 'vue'
import type {ActiveUser} from '@/common/services/ActiveUser/ActiveUserService'

export const useActiveUserStore = defineStore("ACTIVE_USER", () => {

  const activeUser = ref<ActiveUser | null>(null)

  const setActiveUser = (user: ActiveUser | null) => {
    activeUser.value = user
  }

  return {
    activeUser: readonly(activeUser),
    setActiveUser,
  }

})
